import React, { useEffect, useState } from 'react'
import {  BackArrowFeed, EditIconBranding, FavouriteIcon, ManagerHistoryIcon, PersonalizedWellnessHubIcon,AddIconBranding } from '../../utils/icons'
import { DropDownWrapper, PersonalizeHubCard, WellnessHubHeading } from './styles'
import { DropdownContent,/* DropdownContentNew, Layout, OuterContainer*/ } from '../../components/UserDashboard/styles'
import WellnessSlider from '../../components/UserDashboard/WellnessSlider';
import { GetUserWellnessDashboard, GetWellnessHubCategories, GetWellnessPersonalizeCategories } from '../../redux/constants/apiConstants';
import { toast } from 'react-toastify';
import { fetchApi } from '../../utils/methods';
import CommonWellnessCard from './CommonWellnessCard';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { ImageUrl } from '../../utils/constants';
import { t } from 'i18next';
import EditWellnessHub from './EditWellnessHubModal';
import CategorySearchBar from './SearchBar';
import { CommonButtonPopup } from '../../components/HealthCoach/styles';
import SkeletonLoder from '../../components/common/skeletonLoder';
import LazyImage from '../../components/common/LazyImage/LazyImage';
import { Dropdown } from 'react-bootstrap';
import HoverButton from '../../components/common/HoverButton';
import { DownloadButtonWrapper } from '../../components/CompanyEvents/styles';
import PropTypes from "prop-types";
import CommonSliderCard from './CommonSliderCard';

function WellnessHub({/*createRecipePermission,createArticlePermission,*/role}) {
  const [dashboardFeaturedData, setDashboardFeaturedData] = useState([]);
  const [dashboardTrendingData, setDashboardTrendingData] = useState([]);
  const [dashboardRecommededData, setDashboardRecommendedData] = useState([]);
  const [wellnessLoading,setWellnessLoading] = useState(false);
  const [wellnessCategory,setWellnessCategory] = useState([]); 
  const [allCategory,setAllCategory] = useState({});
  const [loading, setLoading] = useState(false);
  const [editWellnessHub, setEditWellnessHub]=useState(false);
  const history = useHistory();
  const [categoryLoading, setCategoryLoading] = useState(false);
  
  // let featuredVideosData = featuredVideos && featuredVideos.length >0 && featuredVideos.slice(0,4);

  useEffect(()=>{
    GetWellnessDashboardData();
    FetchWellnessHubCategories();
    FetchWellnessHubCategory();
  },[])

  const FetchWellnessHubCategories = async()=>{
    setWellnessLoading(true);
    try {
      const res = await fetchApi(GetWellnessPersonalizeCategories, "GET");
      if(res.status === 'success'){
        setWellnessCategory(res.data)
        setWellnessLoading(false);
      }else{
        toast.error((res?.data?.message))
        setWellnessLoading(false)
      }
    } catch (error) {
      window.console.error(error);
    }
  }
  const FetchWellnessHubCategory = async()=>{
    setCategoryLoading(true); 
    try {
      const res = await fetchApi(GetWellnessHubCategories, "GET");
      if(res.status === 'success'){
        // setWellnessCategory(res.data)
        setAllCategory({
          articles: res.data.article_categories || [],
          fitness: res.data.fitness_video_categories || [],
          recipes: res.data.recipe_categories || []
        });
      }else{
        toast.error((res?.data?.message))
      }
    } catch (error) {
      window.console.error(error);
    }
    finally {
      setCategoryLoading(false);   // 👈 stop loading always
    }
  }
    

  const GetWellnessDashboardData= async () => {
    const apiUrl = GetUserWellnessDashboard;
    setLoading(true);
    try{
      const res = await fetchApi(apiUrl,"GET");
      if(res.status === "success"){
        setDashboardFeaturedData(res.data.featured)
        setDashboardTrendingData(res.data.trending);
        setDashboardRecommendedData(res.data.recommended);
        setLoading(false);
      }
      else{
        toast.error(res.message);
        setLoading(false);
      }
    }catch(error){
      window.console.error(error);

    }
  }



  // const SliderCard = ({ data = [], title, type, currentSlide , setCurrentSlide})=>{
  //   window.console.log("data",data)
  //   return(
  //     <OuterContainer isOuterpadding="0 20px 16px 20px">
  //       <Layout margin="20px 0 0 0" padding="0px">
  //         <div className="headingMain">
  //           <div className="heading">{title}</div>
  //         </div>
  //         <SliderContainer currentSlide={currentSlide}>
  //           <Slider {...sliderSettings}   beforeChange={(oldIndex, newIndex) => setCurrentSlide(newIndex)}>
  //             {data?.map((item) => (
  //               <DropdownContentNew key={item.id} onClick={() => history.push({pathname:`/wellness-resources/${type}`,state:{categoryData:item,type:type}})}>
  //                 <img src={`${ImageUrl}/${item.image}`}  className="category-img"  />
  //                 <div className="listContent">{item.category_name}</div>
  //               </DropdownContentNew>
  //             ))}
  //           </Slider>
  //         </SliderContainer>
  //       </Layout>
  //     </OuterContainer>
  //   )
  // }

 

  const FeaturedCard = () => (
    <WellnessSlider
      title="Recommended"  
      data={dashboardFeaturedData} 
      showArrows={true} 
      showDots={true}
      myFocusCard={true}  
      loading={loading} 
      icon={<PersonalizedWellnessHubIcon/>}
    />
  );
  
  

  const TrendingCard = () => (
    <CommonWellnessCard
      title="Trending"  
      showArrows={true} 
      data={dashboardTrendingData} 
      showDots={false}
      loading={false} 
      history={history}
      GetWellnessDashboardData={GetWellnessDashboardData}
    />
  )

  const RecommendedCard = () => (
    <CommonWellnessCard
      title="Featured"  
      showArrows={true} 
      data={dashboardRecommededData} 
      showDots={false}
      loading={false} 
      history={history}
      GetWellnessDashboardData={GetWellnessDashboardData}
    />
  )

  const PersonalizeMyHubCard = ()=>(
    <PersonalizeHubCard>
      <div className='row-one'>
        <div>
          <span className='text'>Tell us what matters most and we’ll  build a wellness hub around your goals.</span>
          <CommonButtonPopup background={"#DA6C74"} margin={"20px 0px 0px 0px"} onClick={()=>setEditWellnessHub(true)}>Personalize My Hub</CommonButtonPopup>
        </div>
        <LazyImage src={ImageUrl + "/education/wellness-hub.png"} style={{height:'100px'}}/>
      </div>
    </PersonalizeHubCard>
  )


  return (
    <div style={{maxWidth: "1246px", padding: "24px 0px 40px 0px",margin: "auto",width: "100%"}}>
      <WellnessHubHeading>
        <div className='right-row'>
          <div className="icon" onClick={() => history.push("/portal")}>
            {BackArrowFeed("#DA6C74")}
          </div>
          <div className="title">{t("Personalized Wellness Hub")}</div>
          <div className="edit-icon" onClick={()=>setEditWellnessHub(true)}>{EditIconBranding('#DA6C74')}</div>
        </div>
        <div className='left-row'>
          <CategorySearchBar/>
          <div className='icons' onClick={()=>history.push('/wellness-resources/watched-history')}>{ManagerHistoryIcon('#DA6C74',16,16)}</div>
          <div className='icons favourite-icon' onClick={()=>history.push('/wellness-resources/saved-data')}><FavouriteIcon fill={"none"}/></div>
         
          {role === "ADMIN" ? <DownloadButtonWrapper isEvent={true}>
            <div className="create-events" style={{padding: "0px"}}> 
              <Dropdown>
                <Dropdown.Toggle>
                  <HoverButton
                    width="24px"
                    height="24px"
                    marginLeft="16px"
                    svgPath={AddIconBranding(24,24)} 
                    activeColor={"#DA6C74"} 
                    fillOpacity={1}
                    inActiveColor={"#DA6C74"}
                    backgroundColor={"rgba(254, 254, 254, 0.60)"}
                    backgroundColorActive={"#DA6C74"}
                    showTooltip={false}
                  />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item onClick={() => history.push(`/education/create-category`)} >Create Category</Dropdown.Item>
                  <Dropdown.Item onClick={() => history.push({pathname:`/wellness-resources/create-recipe`,state:{route:"user"}})} >Create Recipe</Dropdown.Item> 
                  <Dropdown.Item onClick={() => history.push({pathname:`/wellness-resources/create-article`,state:{route:"user"}})} >Create Article</Dropdown.Item>
                  <Dropdown.Item onClick={() => history.push({pathname:`/education/create-video`,state:{route:"user"}})} >Create Fitness Videos</Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </DownloadButtonWrapper>:null}
        </div>
      </WellnessHubHeading>

      {wellnessLoading ? <SkeletonLoder width="1248px" height="100px" style={{ marginTop:"20px" }} /> : wellnessCategory.length ? <DropDownWrapper>
        {wellnessCategory?.map((data, index) => (
          <DropdownContent isBorder={"0.75px solid #DCDCDC"} key={index} onClick={() => history.push({pathname:`/wellness-resources/${data?.type}`,state:{categoryData:data}})}>
            <img src={`${ImageUrl}/${data?.image}`} />
            <div className="listContent">{data?.category_name || data?.recipe_tag}</div>
          </DropdownContent>))}
      </DropDownWrapper> : PersonalizeMyHubCard()}

      {dashboardRecommededData.length && wellnessCategory.length ? FeaturedCard(): null}
      <CommonSliderCard
        data={allCategory?.articles}
        title="Education All Category"
        type="article"
        loading={categoryLoading}
      />
      {/* <SliderCard({data:allCategory?.articles,title:"Education All Category",type:"article",currentSlide:currentSlide,setCurrentSlide:setCurrentSlide, loading: categoryLoading   })/> */}
      <div style={{marginBottom:"35px"}}>
        { TrendingCard() }
      </div> 
      <CommonSliderCard
        data={allCategory?.recipes}
        title="Nutrition Videos All Category"
        type="recipe"
        loading={categoryLoading}
      />
      <div style={{marginBottom:"35px"}}>
        { RecommendedCard() }
      </div> 
      <CommonSliderCard
        data={allCategory?.fitness}
        title="Wellness Videos All Category"
        type="fitness_video"
        loading={categoryLoading}
      />
      {editWellnessHub && <EditWellnessHub show={editWellnessHub} onClose={()=>setEditWellnessHub(false)} fetchWellnessHubCategories={FetchWellnessHubCategories}/>}
    </div>
  )
}

export default WellnessHub;

WellnessHub.propTypes = {
  createRecipePermission: PropTypes.bool,
  createArticlePermission:PropTypes.bool,
  role:PropTypes.string,
  loading:PropTypes.bool,
  data: PropTypes.array,
  type: PropTypes.string,
  title: PropTypes.string,
  currentSlide:PropTypes.number,
  setCurrentSlide:PropTypes.func,
  className:PropTypes.string,
  onClick:PropTypes.func,
  style:PropTypes.object,

};


